import dynamic from 'next/dynamic';
import { ReviewProps } from './Review.types';

export const Review = dynamic<{ model: ReviewProps }>(() => import('./Review').then(mod => mod.Review));
